var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1463 13.5198C14.2903 13.6912 14.3603 13.9128 14.3409 14.1357C14.3215 14.3587 14.2143 14.5649 14.043 14.7088C13.8716 14.8528 13.6501 14.9228 13.4271 14.9034C13.2041 14.884 12.998 14.7768 12.854 14.6055C11.8914 13.4594 10.1955 12.0939 7.59391 12.0939C5.56258 12.0939 3.69438 12.9855 2.33383 14.6055C2.18987 14.7768 1.98373 14.884 1.76075 14.9034C1.53777 14.9228 1.31622 14.8528 1.14485 14.7088C0.973474 14.5649 0.866307 14.3587 0.846923 14.1357C0.827539 13.9128 0.897527 13.6912 1.04149 13.5198C1.95817 12.4127 3.13419 11.5493 4.46501 11.0062C3.63745 10.3556 3.0333 9.46314 2.73662 8.45312C2.43994 7.4431 2.4655 6.36572 2.80974 5.3709C3.15397 4.37609 3.79976 3.51332 4.65724 2.90267C5.51471 2.29202 6.54122 1.96387 7.59391 1.96387C8.6466 1.96387 9.67311 2.29202 10.5306 2.90267C11.3881 3.51332 12.0339 4.37609 12.3781 5.3709C12.7223 6.36572 12.7479 7.4431 12.4512 8.45312C12.1545 9.46314 11.5504 10.3556 10.7228 11.0062C12.0537 11.5491 13.2298 12.4126 14.1463 13.5198ZM7.59391 10.4064C8.26142 10.4064 8.91395 10.2085 9.46896 9.83762C10.024 9.46677 10.4566 8.93966 10.712 8.32296C10.9675 7.70626 11.0343 7.02766 10.9041 6.37298C10.7738 5.71829 10.4524 5.11692 9.9804 4.64492C9.5084 4.17292 8.90703 3.85148 8.25234 3.72126C7.59766 3.59103 6.91906 3.65787 6.30236 3.91331C5.68565 4.16876 5.15855 4.60134 4.7877 5.15636C4.41685 5.71137 4.21891 6.3639 4.21891 7.03141C4.21984 7.92623 4.57572 8.78413 5.20845 9.41687C5.84119 10.0496 6.69909 10.4055 7.59391 10.4064Z",
    fill: "#3A4BA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 11.8125V5.0625",
    stroke: "#3A4BA1",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 6.75L16.3125 5.0625L18 6.75",
    stroke: "#3A4BA1",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSend);
export default __webpack_public_path__ + "static/media/UserSend.c5988555d387b6d9964efaf098bd8cf1.svg";
export { ForwardRef as ReactComponent };